import React, { FC } from 'react';
import { useToggle } from 'react-use';
import { Icon } from '@app/components/Icon';
import { Button } from '@chakra-ui/react';
import { IDerivedMintInfo } from '@app/state/mintStore';
import { CollectFeesModalV3Content } from '@app/screens/positions/components/CollectFeesModalV3/CollectFeesModalV3Content';

interface Props {
  mintInfo: IDerivedMintInfo;
  positionFeesUSD: number;
  positionId: number;
  fullWidth?: boolean;
}

export const CollectFeesModalV3: FC<Props> = ({
  mintInfo,
  positionFeesUSD,
  positionId,
  fullWidth
}) => {
  const [open, toggleOpen] = useToggle(false);

  return (
    <>
      <Button
        width={fullWidth ? '100%' : ['100%', 'fit-content']}
        leftIcon={
          <Icon
            name="arrowTopRight"
            style={{ width: '18px', height: '18px' }}
          />
        }
        variant="rowCompact"
        onClick={toggleOpen}
      >
        Collect fees
      </Button>
      {open && (
        <CollectFeesModalV3Content
          onClose={() => toggleOpen(false)}
          isOpen={open}
          positionFeesUSD={positionFeesUSD}
          mintInfo={mintInfo}
          positionId={positionId}
        />
      )}
    </>
  );
};
